import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "./lib/auth";
import { AppLayout } from "./layout/AppLayout";
import { LoginPage } from "./pages/Login";
import { ProjectsPage } from "./pages/Projects";
import { AssetsPage } from "./pages/Assets";
import { PlaceholderPage } from "./pages/Placeholder";
import { Spin } from "antd";

function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }
  if (status === "anon") {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Navigate to="/projects" replace />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:pid/assets" element={<AssetsPage />} />
        <Route
          path="/experiments"
          element={<PlaceholderPage title="实验" hint="四元组实验管理（S14/S15 落地）" />}
        />
        <Route
          path="/arena"
          element={<PlaceholderPage title="竞技场" hint="多方案任务表现排行（S17/S18 落地）" />}
        />
        <Route
          path="/fleet"
          element={<PlaceholderPage title="设备舰队" hint="真机接入与动作下发（S26-S30 落地）" />}
        />
        <Route
          path="/models"
          element={<PlaceholderPage title="模型" hint="策略版本与训练任务（S31-S34 落地）" />}
        />
        <Route
          path="/settings"
          element={<PlaceholderPage title="设置" hint="租户/成员/密钥管理（S35 落地）" />}
        />
        <Route path="*" element={<Navigate to="/projects" replace />} />
      </Route>
    </Routes>
  );
}
